// @dynamic-i18n-keys
// Dynamic t() at line 46: transKey from ternary (isPaidFolder / isWatchToAccess).
//   deviationview.paywall.thumb.premiumFolder.tooltip
//   deviationview.paywall.thumb.watchersOnly.tooltip
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiPremiumFolderData } from '@wix/da-papi-types';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/24x24/EyeDisc2';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';

export interface Props {
  premiumFolderData?: PapiPremiumFolderData;
  className?: string;
  withTooltip?: boolean;
  tooltipClassName?: string;
  size?: IconSize;
}

const PremiumIcon: React.FC<Props> = ({
  className,
  premiumFolderData,
  withTooltip = true,
  tooltipClassName,
  size = IconSize.MEDIUM,
}) => {
  const { t } = useTranslation();
  const { isPremium, isPaidFolder, isWatchToAccess } =
    normalizePremiumFolderData(premiumFolderData);

  if (!isPremium) {
    return null;
  }

  const icon = isPaidFolder ? (
    <PremiumGallery size={size} className={className} />
  ) : isWatchToAccess ? (
    <EyeDisc2 size={size} className={className} />
  ) : null;

  const transKey = isPaidFolder
    ? 'deviationview.paywall.thumb.premiumFolder.tooltip'
    : isWatchToAccess
      ? 'deviationview.paywall.thumb.watchersOnly.tooltip'
      : '';

  return withTooltip ? (
    <SimpleTooltip text={t(transKey)} className={tooltipClassName} usePortal>
      {icon}
    </SimpleTooltip>
  ) : (
    icon
  );
};
PremiumIcon.displayName = 'PremiumIcon';

export default PremiumIcon;
